import { matchesRef } from '../../../schema/validation/resourceObject'
import { type BoardObjectsTransform, type IncludedRef } from './types'

export const removeIncluded =
  (ref: IncludedRef): BoardObjectsTransform =>
  (draft) => {
    if (!draft.included) return draft

    const matches = matchesRef(ref)
    draft.included = draft.included.filter((resource) => !matches(resource))
    return draft
  }
